import { z } from "zod";

const envSchema = z.object({
  VITE_APP_ENV: z.enum(["development", "staging", "production"]).default("development"),
  VITE_ADMIN_API_BASE_URL: z.string().url().default("https://staging.api.wear.zone"),
  /**
   * Admin API source toggle.
   *
   *   "mock" → src/lib/api/admin-mock-client (in-memory typed fixtures)
   *   "real" → src/lib/api/admin-real-client (HTTP calls to VITE_ADMIN_API_BASE_URL)
   *
   * Defaults to "mock" so a fresh checkout never hits a missing/staging backend.
   * Flip to "real" in .env.local / staging env when the backend is reachable.
   */
  VITE_ADMIN_API_MODE: z.enum(["mock", "real"]).default("mock"),
  VITE_SENTRY_DSN: z.string().optional().default(""),
  VITE_POSTHOG_KEY: z.string().optional().default(""),
});

const parsed = envSchema.safeParse(import.meta.env);

if (!parsed.success) {
  // Surface configuration errors loudly during bootstrap rather than letting
  // them propagate as runtime nulls.

  console.error("Invalid environment configuration", parsed.error.flatten());
  throw new Error("Invalid environment configuration. See console for details.");
}

export const env = parsed.data;

export const isProduction = env.VITE_APP_ENV === "production";
export const isStaging = env.VITE_APP_ENV === "staging";
export const isDevelopment = env.VITE_APP_ENV === "development";

export type AppEnv = (typeof env)["VITE_APP_ENV"];
export type AdminApiMode = (typeof env)["VITE_ADMIN_API_MODE"];
